import React from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  onEnter?: () => void;
}

const TableSearchInput: React.FC<Props> = ({
  value,
  onChange,
  placeholder = "Search...",
  onEnter,
}) => (
  <div className="tableCardHeader__searchWrap">
    <i className="bi bi-search tableCardHeader__searchIcon" aria-hidden="true" />
    <input
      type="text"
      className="tableCardHeader__searchInput"
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e?.target?.value ?? "")}
      onKeyDown={(e) => {
        if (e.key === "Enter" && onEnter) onEnter();
      }}
    />
  </div>
);

export default TableSearchInput;
